import React from "react";
import { type SuperPageAssignment } from "@/services/bedrock";
import { SuperPageAssignmentCard } from "./SuperPageAssignmentCard";

type Props = {
  content: SuperPageAssignment[];
  isFetching: boolean;
  onAssignmentClick: (assignmentId: number) => void;
};

const SuperPageAssignmentsContent: React.FC<Props> = ({ content, isFetching, onAssignmentClick }) => {
  return (
    <>
      {content.map(assignment => (
        <SuperPageAssignmentCard
          key={`super-page-assignment-${assignment.id}`}
          assignment={assignment}
          onClick={() => onAssignmentClick(assignment.id)}
          disabled={isFetching}
        />
      ))}

      {isFetching && content.length === 0 && <SuperPageAssignmentCard dataSkeleton />}
    </>
  );
};

export { SuperPageAssignmentsContent };
